import { ReactNode } from 'react';
import { GridColumnContainer } from '../../pages/MainPage/styles';

const TabCorrect = ({ commands }: { commands: string[] }): ReactNode => {
  const result: ReactNode = commands?.sort().map((cmd: string, idx: number) => <p key={`tab-${idx}`}>{cmd}</p>);
  return <GridColumnContainer>{result}</GridColumnContainer>;
};

export default TabCorrect;
